import { render } from "./DockerRegistriesModal.vue?vue&type=template&id=24de4aae&scoped=true"
import script from "./DockerRegistriesModal.vue?vue&type=script&lang=js"
export * from "./DockerRegistriesModal.vue?vue&type=script&lang=js"

import "./DockerRegistriesModal.vue?vue&type=style&index=0&id=24de4aae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24de4aae"]])

export default __exports__